import React, { useEffect } from "react";
import "./Dashboard.css";
import Layout from "../../Components/Layout/Layout";
import InfoDashboard from "../../Components/InfoDashboard/InfoDashboard";
import TwitterFeed from "../../Components/TwitterFeed/TwitterFeed";
import { useOktaAuth } from "@okta/okta-react";
import CompetitiveIntelligence from "../../Components/CompetitiveIntelligence/CompetitiveIntelligence";

const Dashboard = () => {
  const auth = useOktaAuth();
  useEffect(() => {
    const getUser = async () => {
      try {
      } catch (error) {}
    };
    const fetchState = () => {
      auth.oktaAuth.token
        .parseFromUrl()
        .then(async () => {})
        .catch(() => {});
    };
    fetchState();
    auth.authState?.isAuthenticated && getUser();
  }, [auth.authState, auth.oktaAuth]);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Layout>
      <div
        className="child-section-of-everypage"
        style={{ paddingTop: isMobile ? "65px" : "",marginBottom: isMobile ? "0px" : "" }}
      >
        <InfoDashboard />
        {/* <TwitterFeed /> */}
        <CompetitiveIntelligence />
      </div>
    </Layout>
  );
};
export default Dashboard;
